import GetPrivateData from './GetPrivateData.js';

export default class ElementFinder
{
	constructor(elements,predicate)
	{
		const privateData = getPrivateData.for(this);
		privateData.list = new WeakSet();
		privateData.callbacks = new Map;
		privateData.elements = [].concat(elements).map( v => v && v.toUpperCase && v.toUpperCase() || '' ).filter( v => v);
		privateData.predicate = predicate;
		privateData.foundElements = new WeakSet;
	}

	track(document)
	{
		if(!document)
		{
			return;
		}

		const privateData = getPrivateData.for(this);

		if(privateData.list.has(document))
		{
			return;
		}

		privateData.list.add(document);

		// const position = positionOf(document.defaultView);
		// console.log('Tracking document: ' + position );

		document.defaultView.addEventListener
		(
			'load',
			event =>
			{
				const window = event.target;
				this.track(window.document);
			}
		);

		new MutationObserver
		(
			mutationRecords =>
			{
				mutationRecords.forEach
				(
					mutationRecord =>
					{
						mutationRecord.addedNodes.forEach
						(
							node =>
							{
								if(node.nodeType !== node.ELEMENT_NODE)
								{
									return;
								}
								if(node.nodeName === 'IFRAME')
								{
									watchIframe.call(this,node);
								}
								if(privateData.elements.indexOf(node.nodeName) !== -1)
								{
									foundElement.call(this,node,true);
								}
							}
						);
						mutationRecord.removedNodes.forEach
						(
							node =>
							{
								if(node.nodeType !== node.ELEMENT_NODE)
								{
									return;
								}
								if(privateData.elements.indexOf(node.nodeName) !== -1)
								{
									foundElement.call(this,node,false);
								}
							}
						);
					}
				)
			}
		)
			.observe
			(
				document,
				{
					childList: true,
					subtree: true
				}
			);

		Array.from(document.querySelectorAll('iframe')).forEach
		(
			element => watchIframe.call(this,element)
		);

		Array.from(document.querySelectorAll(privateData.elements.join(','))).forEach
		(
			element => foundElement.call(this,element)
		);
	}

	addEventListener(type,callback)
	{
		const privateData = getPrivateData.for(this);

		const callbacks = privateData.callbacks.get(type) || privateData.callbacks.set(type,new Set()).get(type);
		if(callbacks.has(callback))
		{
			return;
		}
		callbacks.add(callback);
	}

	removeEventListener(type,callback)
	{
		const privateData = getPrivateData.for(this);

		const callbacks = privateData.callbacks.get(type);
		if(!callbacks)
		{
			return;
		}
		callbacks.delete(callback);
		if(!callbacks.size)
		{
			privateData.callbacks.delete(type);
		}
	}
}

function watchIframe(iframe)
{
	try
	{
		iframe.addEventListener
		(
			'load',
			() =>
			{
				this.track(iframe.contentDocument);
			}
		);
		this.track(iframe.contentDocument);
	}
	catch(e)
	{

	}
}

function foundElement(element,added)
{
	const privateData = getPrivateData.for(this);

	if(added)
	{
		let result = !privateData.predicate;
		try
		{
			if(!result)
			{
				result = privateData.predicate(element);
			}
		}
		catch(e)
		{
			result = false;
		}
		if(result)
		{
			privateData.foundElements.add(element);
			dispatchEvent.call(this,'inserted',element);
		}
	}
	else
	{
		if(privateData.foundElements.has(element))
		{
			privateData.foundElements.delete(element);
			dispatchEvent.call(this,'removed',element);
		}
	}
}

function dispatchEvent(type,data)
{
	const privateData = getPrivateData.for(this);

	if(!privateData.callbacks.has(type))
	{
		return;
	}
	privateData.callbacks.get(type).forEach
	(
		callback => callback.apply(this,[].concat(data))
	);
}

// function positionOf(window)
// {
// 	if(!window)
// 	{
// 		return null;
// 	}
//
// 	const position = [];
//
// 	let win = window;
// 	while(win.parent && win !== window.top)
// 	{
// 		let index = win.parent.frames.length;
// 		while(index--)
// 		{
// 			if(win.parent.frames[index] === win)
// 			{
// 				break;
// 			}
// 		}
// 		position.unshift(index);
// 		win = win.parent;
// 	}
// 	position.unshift('top');
// 	return position.join('.');
// }

const getPrivateData = new GetPrivateData(ElementFinder);